export default __webpack_public_path__ + "pdfjs-dist-ie11-ledge/pdf.worker.min-3e881a0bba3266926e0b1d7e5c5f9625.js";